const amlbotProURL =
  (import.meta.env.VITE_REACT_APP_PRO_AMLBOT_URL as string) || '*';

function notifyProVersion(param: string) {
  if (window?.opener) {
    if (param === 'signIn' || param === 'signOut') {
      const messageData = {
        type: param,
      };
      window.opener.postMessage(messageData, amlbotProURL);
    }
  }
}

function checkIfFromProVersion() {
  const queryParams = new URLSearchParams(window.location.search);
  const paramValue = queryParams.get('fromPro');
  return !!paramValue;
}

export { notifyProVersion, checkIfFromProVersion };
